import { motion } from "framer-motion";
import { CTAButton } from "./CTAButton";
import { useLang } from "../../i18n/LanguageContext";
import { useJourney } from "../../context/JourneyContext";

const row = {
  hidden: { opacity: 0, y: 24 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: i * 0.05 },
  }),
};

export const Process = () => {
  const { t } = useLang();
  const { journey } = useJourney();
  const isLocal = journey === "local";
  const title = isLocal ? t.processLocal.title : t.process.title;
  const sub = isLocal ? t.processLocal.sub : t.process.sub;
  const steps = isLocal
    ? [t.process.steps[0], t.process.steps[2], t.process.steps[7]]
    : t.process.steps;
  return (
    <section id="process" className="relative py-24 sm:py-32 bg-green text-cream overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl"
        >
          <span className="text-xs uppercase tracking-[0.25em] text-cream/50 font-semibold">{t.process.overline}</span>
          <h2 className="mt-5 font-display font-semibold tracking-tight leading-[1.02] text-3xl sm:text-5xl lg:text-6xl">
            {title}
          </h2>
          <p className="mt-6 text-base sm:text-lg text-cream/70 leading-relaxed">{sub}</p>
        </motion.div>

        <div className="mt-14 sm:mt-20 border-t border-cream/15">
          {steps.map((s, i) => (
            <motion.div
              key={i}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-40px" }}
              variants={row}
              data-testid={`process-step-${i}`}
              className="group grid grid-cols-12 items-baseline gap-4 py-6 sm:py-8 border-b border-cream/15
                         transition-colors duration-300 hover:bg-cream/[0.04]"
            >
              <div className="col-span-2 sm:col-span-1">
                <span className="font-display text-cream/40 text-2xl sm:text-4xl leading-none">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="col-span-10 sm:col-span-8">
                <h3 className="font-display text-xl sm:text-3xl leading-tight text-cream">{s.title}</h3>
              </div>
              <div className="col-span-12 sm:col-span-3 sm:text-right pl-14 sm:pl-0">
                <span className="text-sm sm:text-base text-cream/60 tracking-wide">{s.time}</span>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-12 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-8"
        >
          <p className="max-w-xl text-base sm:text-lg text-cream/80 leading-relaxed">{t.process.note}</p>
          <CTAButton testId="process-cta" label={t.process.cta} variant="invert" />
        </motion.div>
      </div>
    </section>
  );
};
